import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';
import {
  bankInitials,
  bankLogoUrl,
} from '@features/dashboard/dashboard-management/components/home-bank-limits-card/bank-limits-display.util';

/**
 * Avatar redondo de banco do card "Limites Bancários" (card 3786, crítica de design G2). Mostra o logo
 * pelo código COMPE inteiro dentro do círculo (`object-fit: contain` com respiro interno) e, quando não
 * há código ou a imagem não carrega, as iniciais em fundo navy. Não usa o `app-bank-logo` porque ele
 * cai no logo genérico (`0.png`) quando falta o arquivo, o que aparecia como círculo branco vazio.
 */
@Component({
  selector: 'app-home-bank-avatar',
  standalone: true,
  template: `
    <span
      class="bank-avatar"
      [class.bank-avatar--small]="size() === 'small'"
      [class.bank-avatar--logo]="showLogo()"
      [title]="bankName()">
      @if (showLogo()) {
        <img
          [src]="logoUrl()"
          [alt]="'Logo ' + bankName()"
          loading="lazy"
          (error)="failed.set(true)" />
      } @else {
        <span aria-hidden="true">{{ initials() }}</span>
      }
    </span>
  `,
  styleUrls: ['./home-bank-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBankAvatarComponent {
  readonly bankName = input('');
  readonly bankCode = input<string | null>(null);
  readonly size = input<'normal' | 'small'>('normal');

  readonly failed = signal(false);
  readonly logoUrl = computed(() => bankLogoUrl(this.bankCode()));
  readonly initials = computed(() => bankInitials(this.bankName()));
  readonly showLogo = computed(() => !!this.logoUrl() && !this.failed());

  constructor() {
    // Outro banco no mesmo avatar: tenta o logo de novo.
    effect(() => {
      this.bankCode();
      this.failed.set(false);
    });
  }
}
